import React, { useEffect, useState } from "react";
import { apiFetch } from "../utils/api";
import BuscadorCatalogo, { coincideBusqueda } from "./BuscadorCatalogo";
import Cargando from "./Cargando";

function GestionarCategoriasProveedor() {
  const [categorias, setCategorias] = useState([]);
  const [areas, setAreas] = useState([]);
  const [mapa, setMapa] = useState({}); // { [categoria_id]: Set<area_id> }

  const [nombre, setNombre] = useState("");
  const [areaIdsForm, setAreaIdsForm] = useState([]);
  const [editandoId, setEditandoId] = useState(null);
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState("");
  const [cargando, setCargando] = useState(true);
  const [busqueda, setBusqueda] = useState("");

  const cargar = () => {
    setCargando(true);
    Promise.all([
      apiFetch("/api/categorias-proveedor"),
      apiFetch("/api/areas"),
      apiFetch("/api/categorias-proveedor/visibilidad"),
    ])
      .then(([categoriasData, areasData, visibilidadData]) => {
        setCategorias(categoriasData || []);
        setAreas(areasData || []);
        const m = {};
        (visibilidadData || []).forEach((v) => {
          if (!m[v.categoria_id]) m[v.categoria_id] = new Set();
          m[v.categoria_id].add(v.area_id);
        });
        setMapa(m);
      })
      .catch((err) => setError(err.message))
      .finally(() => setCargando(false));
  };

  useEffect(cargar, []);

  const alternarArea = (areaId) => {
    setAreaIdsForm((prev) =>
      prev.includes(areaId) ? prev.filter((id) => id !== areaId) : [...prev, areaId]
    );
  };

  const guardar = async (e) => {
    e.preventDefault();
    setError("");
    if (!nombre.trim()) return;
    setGuardando(true);
    try {
      let id = editandoId;
      if (editandoId) {
        await apiFetch(`/api/categorias-proveedor/${editandoId}`, {
          method: "POST",
          body: JSON.stringify({ nombre }),
        });
      } else {
        const creada = await apiFetch("/api/categorias-proveedor", {
          method: "POST",
          body: JSON.stringify({ nombre }),
        });
        id = creada.id;
      }
      // Qué áreas la pueden ver se guarda de una vez, junto con el nombre —
      // así no hay que ir a buscarla después en la matriz de abajo.
      await apiFetch(`/api/categorias-proveedor/${id}/areas`, {
        method: "POST",
        body: JSON.stringify({ area_ids: areaIdsForm }),
      });
      setNombre("");
      setAreaIdsForm([]);
      setEditandoId(null);
      cargar();
    } catch (err) {
      setError(err.message);
    } finally {
      setGuardando(false);
    }
  };

  const editar = (categoria) => {
    setEditandoId(categoria.id);
    setNombre(categoria.nombre);
    setAreaIdsForm([...(mapa[categoria.id] || [])]);
  };

  const cancelarEdicion = () => {
    setEditandoId(null);
    setNombre("");
    setAreaIdsForm([]);
  };

  const eliminar = async (id) => {
    if (!window.confirm("¿Eliminar esta categoría?")) return;
    try {
      await apiFetch(`/api/categorias-proveedor/${id}/eliminar`, { method: "POST", body: JSON.stringify({}) });
      cargar();
    } catch (err) {
      setError(err.message);
    }
  };

  const nombresAreas = (categoriaId) =>
    areas
      .filter((a) => mapa[categoriaId]?.has(a.id))
      .map((a) => a.nombre);

  const categoriasVisibles = categorias.filter((c) => coincideBusqueda(busqueda, [c.nombre, ...nombresAreas(c.id)]));

  return (
    <div style={styles.card}>
      <div style={styles.cardHeader}>
        <span style={styles.cardIcono}>🏷️</span>
        <div style={{ textAlign: "center" }}>
          <h3 style={{ margin: 0, fontSize: "1rem", color: "var(--tema-titulo, #0b3c60)" }}>Categorías de Proveedor</h3>
          <p style={{ margin: "0.1rem 0 0", fontSize: "0.78rem", color: "#8993a1" }}>
            {categorias.length} registro{categorias.length === 1 ? "" : "s"}
          </p>
        </div>
      </div>

      <form onSubmit={guardar} style={styles.form}>
        <input
          type="text"
          value={nombre}
          onChange={(e) => setNombre(e.target.value)}
          placeholder="Ej. Tecnología"
          style={styles.input}
        />

        <div style={{ marginTop: "0.6rem" }}>
          <div style={{ fontSize: "0.78rem", fontWeight: 600, color: "#5b6472", marginBottom: "0.35rem" }}>
            Qué áreas pueden ver esta categoría (opcional — sin marcar ninguna, la ven todas)
          </div>
          <div style={styles.areasGrid}>
            {areas.map((a) => (
              <label key={a.id} style={styles.areaCheck}>
                <input
                  type="checkbox"
                  checked={areaIdsForm.includes(a.id)}
                  onChange={() => alternarArea(a.id)}
                />
                {a.nombre}
              </label>
            ))}
          </div>
        </div>

        <div style={{ marginTop: "0.75rem" }}>
          <button type="submit" disabled={guardando} style={styles.botonAgregar}>
            {guardando ? "Guardando..." : editandoId ? "Guardar cambios" : "+ Agregar"}
          </button>
          {editandoId && (
            <button type="button" onClick={cancelarEdicion} style={styles.botonCancelar}>
              Cancelar
            </button>
          )}
        </div>
      </form>

      {error && <p style={{ color: "#a3402f" }}>{error}</p>}

      {cargando ? (
        <Cargando compacto />
      ) : categorias.length === 0 ? (
        <p className="vacio-simple">Todavía no hay categorías.</p>
      ) : (
        <>
        <BuscadorCatalogo
          valor={busqueda}
          onCambiar={setBusqueda}
          placeholder="Buscar por categoría o por área…"
          mostrados={categoriasVisibles.length}
          total={categorias.length}
        />
        <div className="table-scroll" style={styles.tablaWrap}>
          <table style={styles.tabla}>
            <thead>
              <tr style={{ textAlign: "left", borderBottom: "1px solid #d3d9df" }}>
                <th style={styles.th}>Nombre</th>
                <th style={styles.th}>Áreas que la ven</th>
                <th style={{ ...styles.th, width: 200 }}></th>
              </tr>
            </thead>
            <tbody>
              {categoriasVisibles.map((c, i) => {
                const nombres = nombresAreas(c.id);
                return (
                  <tr
                    key={c.id}
                    style={{
                      borderBottom: "1px solid #eef1f3",
                      background: editandoId === c.id ? "#f2e3d1" : i % 2 === 1 ? "#fafbfc" : "transparent",
                    }}
                  >
                    <td style={styles.td}>
                      <span style={styles.dot} />
                      {c.nombre}
                    </td>
                    <td style={styles.td}>
                      {nombres.length === 0 ? (
                        <span style={{ color: "#8993a1", fontSize: "0.8rem" }}>Todas</span>
                      ) : (
                        nombres.map((n) => (
                          <span key={n} style={styles.badgeArea}>
                            {n}
                          </span>
                        ))
                      )}
                    </td>
                    <td style={{ ...styles.td, width: 200 }}>
                      <div style={styles.accionesFila}>
                        <button onClick={() => editar(c)} style={styles.botonFila}>
                          ✏️ Editar
                        </button>
                        <button onClick={() => eliminar(c.id)} style={styles.botonFilaPeligro}>
                          🗑️ Eliminar
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        </>
      )}
    </div>
  );
}

const styles = {
  card: {
    border: "1px solid #e2e6ea",
    borderRadius: 14,
    padding: "1.1rem 1.2rem",
    background: "#fff",
    boxShadow: "0 1px 3px rgba(27,42,74,0.06)",
  },
  cardHeader: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "0.4rem",
    marginBottom: "1rem",
  },
  cardIcono: {
    width: 34,
    height: 34,
    borderRadius: 9,
    background: "#f2e3d1",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "1.1rem",
    flexShrink: 0,
  },
  form: {
    border: "1px solid #eef1f3",
    borderRadius: 10,
    padding: "0.9rem 1rem",
    marginBottom: "1rem",
    background: "#fafbfc",
  },
  input: {
    width: "100%",
    boxSizing: "border-box",
    padding: "0.45rem 0.6rem",
    border: "1px solid #d3d9df",
    borderRadius: 6,
    fontFamily: "inherit",
    fontSize: "0.88rem",
  },
  areasGrid: {
    display: "flex",
    flexWrap: "wrap",
    gap: "0.4rem 1rem",
  },
  areaCheck: {
    display: "inline-flex",
    alignItems: "center",
    gap: "0.35rem",
    fontSize: "0.83rem",
    color: "var(--tema-titulo, #0b3c60)",
  },
  botonAgregar: {
    background: "#b8722a",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    padding: "0.5rem 1rem",
    fontSize: "0.85rem",
    fontWeight: 600,
    cursor: "pointer",
    marginRight: "0.5rem",
  },
  botonCancelar: {
    background: "#fff",
    color: "var(--tema-titulo, #0b3c60)",
    border: "1px solid #d3d9df",
    borderRadius: 8,
    padding: "0.5rem 1rem",
    fontSize: "0.85rem",
    fontWeight: 600,
    cursor: "pointer",
  },
  tablaWrap: { border: "1px solid #eef1f3", borderRadius: 10 },
  tabla: { width: "100%", borderCollapse: "collapse", fontSize: "0.88rem" },
  th: {
    padding: "0.55rem 0.5rem",
    background: "#eef1f3",
    border: "1px solid #d3d9df",
    fontSize: "0.76rem",
    fontWeight: 700,
    color: "var(--tema-titulo, #0b3c60)",
  },
  td: { padding: "0.5rem 0.6rem", textAlign: "left" },
  dot: {
    display: "inline-block",
    width: 8,
    height: 8,
    borderRadius: "50%",
    marginRight: "0.55rem",
    background: "#b8722a",
  },
  badgeArea: {
    display: "inline-block",
    padding: "0.12rem 0.5rem",
    borderRadius: 999,
    fontSize: "0.72rem",
    fontWeight: 600,
    color: "var(--tema-primario, #2f6690)",
    background: "var(--tema-suave, #dceaf5)",
    marginRight: "0.3rem",
    marginBottom: "0.2rem",
  },
  accionesFila: {
    display: "flex",
    gap: "0.4rem",
    justifyContent: "flex-end",
    flexWrap: "nowrap",
  },
  botonFila: {
    border: "1px solid #d3d9df",
    background: "#fff",
    borderRadius: 6,
    padding: "0.28rem 0.5rem",
    fontSize: "0.75rem",
    fontWeight: 600,
    color: "var(--tema-titulo, #0b3c60)",
    cursor: "pointer",
    whiteSpace: "nowrap",
  },
  botonFilaPeligro: {
    border: "1px solid #f7ded9",
    background: "#fff",
    borderRadius: 6,
    padding: "0.28rem 0.5rem",
    fontSize: "0.75rem",
    fontWeight: 600,
    color: "#a3402f",
    cursor: "pointer",
    whiteSpace: "nowrap",
  },
};

export default GestionarCategoriasProveedor;
